<template>
  <div class="container">
    <slot></slot>
  </div>
</template>

<script>
  export default
  {

  }
</script>

<style lang="scss">
  .container {
    margin-left: auto;
    margin-right: auto;

    @include mq(desktop) {
      width: $container-desktop;
      /*background: rgba(green, 0.2);*/
    }
    @include mq(scale) {
      width: #{$container-desktop/nth(map-get($breakpoints, desktop), 1) * 100%};
      /*background: rgba(orange, 0.2);*/
    }
    @include mq(tablet) {
      /*background: rgba(blue, 0.2);*/
    }
    @include mq(mobile) {
      /*background: rgba(#fff, 0.2);*/
    }
    @include less(tablet) {
      box-sizing: content-box;
      padding-left: $padding-mobile;
      padding-right: $padding-mobile;
    }
    @include mq(xmobile) {
      padding-left:20px;
      padding-right: 20px;
    }
  }
</style>
